import styled from 'styled-components';
import { Heading3 } from '../Typography/Heading';
import { TextRegular } from '../Typography/Typography';
import { windowMaxWidth } from './breakpoints';

const TypeListContainer = styled.div`
  background: var(--greyscale-porcelain);
  display: flex;
  gap: 20px;
  height: 100%;
  min-width: 0;
  overflow: hidden;
`;

const TypeListWrapper = styled.div`
  background-color: var(--greyscale-white);
  border: 1px solid var(--greyscale-dark-white);
  border-radius: var(--border-radius-regular);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
  width: 310px;

  @media ${windowMaxWidth.splitScreen} {
    width: 250px;
  }
`;

const TypeListHeader = styled.div`
  align-items: flex-start;
  border-bottom: 1px solid var(--greyscale-dark-white);
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 10px;
  padding: 20px;
`;

const TypeListTitle = styled(Heading3)`
  margin: 0;
`;

const TypeListItems = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden auto;
`;

const TypeListItem = styled.button.attrs({ type: 'button' })`
  background: none;
  border: none;
  cursor: pointer;
  font: inherit;
  padding: 12px 16px;
  text-align: left;
  width: 100%;

  &:hover div {
    color: var(--greyscale-blackish);
  }
`;

const TypeListItemName = styled(TextRegular)`
  color: ${({ $active }) => ($active ? 'var(--greyscale-blackish)' : 'var(--greyscale-shade)')};
  display: block;
  font-weight: ${({ $active }) => ($active ? 'var(--font-weight-medium)' : 'var(--font-weight-regular)')};
`;

const TypeListEmpty = styled.div`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  padding: 24px 16px;
  text-align: center;
`;

const TypeDetailWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
`;

const TypeDetailPlaceholder = styled.div`
  align-items: center;
  color: var(--greyscale-shade);
  display: flex;
  flex: 1;
  font-size: var(--font-size-regular);
  justify-content: center;
  padding: 48px;
`;

const OrganizationTypeListLayout = {
  TypeDetailPlaceholder,
  TypeDetailWrapper,
  TypeListContainer,
  TypeListEmpty,
  TypeListHeader,
  TypeListItem,
  TypeListItemName,
  TypeListItems,
  TypeListTitle,
  TypeListWrapper
};

export default OrganizationTypeListLayout;
